import { FINANCE_SERVER } from '@/constants/domains'
import VueCookie from 'vue-cookie'
const axios = require('axios')

export default {
  getEmailById ({messageId}) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.get(`usermessages/${messageId}`)
  },
  updateEmailStatus (email) {
    email.company = VueCookie.get('company')
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.put('usermessages/' + email.messageId, email)
  },
  removeJobNotification ({delayedJobId}) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.delete('jobnotifications/' + delayedJobId)
  }
}



// WEBPACK FOOTER //
// ./src/api/EmailStats/api.js